<template>
  <div class="newrepair-page">
    <el-breadcrumb separator="/" class="breadcrumb">
      <template v-for="breadcrumb in Breadcrumbs">
        <el-breadcrumb-item :key="breadcrumb.name" v-if="breadcrumb.to" :to="breadcrumb.to">{{breadcrumb.name}}</el-breadcrumb-item>
        <el-breadcrumb-item :key="breadcrumb.name" v-else>{{breadcrumb.name}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
    <div class="card">
      <div class="search-box">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="80px">
          <el-form-item label="维修类型" prop="library">
            <el-select v-model="ruleForm.library" clearable  placeholder="请选择维修类型" >
              <el-option
                v-for="item in librarys"
                :key="item.value"
                :label="item.label"
                :disabled="item.flag"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域" prop="region">
            <el-select v-model="ruleForm.region"  placeholder="请选择区域" >
              <el-option
                v-for="item in regions"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="item-box" v-for="(s,index) in services">
            <table>
              <tbody>
                <tr >
                  <td width="20%">
                    <label><span style="color:red;padding-right:5px"> * </span>物料名称</label>
                      <el-select v-model="s.ProductId"
                      v-if="ruleForm.library !== 'external'"
                      filterable remote 
                      placeholder="物料名称/编码" 
                      :remote-method="remoteMethod"
                      @change="pullLots(s)">
                        <el-option
                          v-for="item in materiels"
                          :key="item.Id"
                          :label="NameCode(item)"
                          :value="item.Id">
                        </el-option>
                      </el-select>
                    <el-input v-model="s.ProductName" placeholder="物料名称/编码"></el-input>
                  </td>
                  <td width="18%"
                  v-if="ruleForm.library !== 'external'">
                    <label>批次号</label>
                    <el-select v-model="s.LotId" filterable remote :remote-method="remoteLot" placeholder="批次号">
                      <el-option
                        v-for="item in Lots"
                        :key="item.Id"
                        :label="item.Code"
                        :value="item.Id">
                      </el-option>
                    </el-select>
                  </td>
                  <td width="18%" v-else>
                    <label>批次号</label>
                    <el-input v-model="s.LotCode" placeholder="可不填"></el-input>
                  </td>
                  <td width="16%">
                    <label><span style="color:red;padding-right:5px"> * </span>品项</label>
                    <el-select v-model="s.ConditionId" filterable  placeholder="品项">
                      <el-option
                        v-for="item in ProductCondition"
                        :key="item.Id"
                        :label="item.Name"
                        :value="item.Id">
                      </el-option>
                    </el-select>
                  </td>
                  <td width="5%">
                    <label>数量</label>
                    <label class="quantityLabel">{{s.Quantity}}</label>
                  </td>
                  <td width="40%">
                    <label>维修原因</label>
                    <el-input v-model="s.Description" placeholder="维修原因"></el-input>
                  </td>
                </tr>
                <tr v-if="ruleForm.library === 'external'">
                  <td>
                    <label>品牌</label>
                    <el-input v-model="s.BrandName" placeholder="可不填"></el-input>
                  </td>
                  <td>
                    <label>机型</label>
                    <el-input v-model="s.ModelName" placeholder="可不填"></el-input>
                  </td>
                  <td style="padding-right:20px">
                    <label>模块</label>
                    <el-input v-model="s.ModuleName" placeholder="可不填"></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
          <el-button class="delete-btn" @click.native="deleteItem(index)">X</el-button>
          </div>
        </el-form>
      </div>
    </div>
    <div class="btn-box">
      <el-button type="primary" class="inquire pull-left" @click.native="addBatch">新增</el-button>
      <el-button type="primary" class="pull-right" style="margin-left:15px;" @click.native="submit">提交并等待客服联系</el-button>
      <el-button class="pull-right" @click.native="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import o from '@/odata'
import { Loading } from 'element-ui'
let timer
export default {
  mounted() {
    this.initservices()
    this.initProductCondition()
    // 初始化模块下拉框
    this.initModules()
    this.initRegions()
    this.ruleForm.library = 'external' // 默认维修类型为外部维修
  },
  data() {
    return {
      Breadcrumbs: [
        {
          to: { name: 'RepairList' },
          name: '维修订单列表',
        },
        {
          name: '新建维修订单',
        },
      ],
      ruleForm: {
        library: '',
        region: '',
      },
      rules: {
        library: [{ required: true, message: '必填' }],
        region: [{ required: true, message: '必填' }],
      },
      services: [],
      materiels: [],
      regions: [],
      Lots: [],
      sendform: [],
      ProductCondition: [],
      changeProductId: '',
      modules: [],
      librarys: [
        // {label: '自建维修', value: 'custom', flag: false},
        {label: '外部维修', value: 'external', flag: false},
      ],
    }
  },
  methods: {
    cancel: function() {
      this.$router.push('/repair')
    },
    submit: function() {
      // 维修订单验证
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 维修批次验证
          for (let a = 0; a < this.services.length; a++) {
            if (!this.services[a].ProductName) {
              // 未填写物料名称
              return this.$message({
                message: '请输入第' + (a + 1) + '个物料的名称',
                type: 'info',
              })
            }
            console.log('this.services[a].ProductName.length', this.services[a].ProductName.length)
            if (this.services[a].ProductName.length > 18) {
              // 物料名称长度大于18
              return this.$message({
                message: '第' + (a + 1) + '个物料的名称长度超过了18个字符',
                type: 'info',
              })
            }
            if (!this.services[a].ConditionId) {
              // 未填写物料品项
              return this.$message({
                message: '请选择第' + (a + 1) + '个物料的品项',
                type: 'info',
              })
            }
          }
          // 清空表单
          this.sendform = []
          // 显示加载页面
          let loading = Loading.service({text: '正在提交订单,请稍后', customClass: 'comfirmLoading'})
          if (this.ruleForm.library !== 'external') {
            for (let a = 0; a < this.services.length; a++) {
              this.sendform.push({
                LotId: this.services[a].LotId,
                Description: this.services[a].Description,
                Quantity: this.services[a].Quantity,
              })
            }
          } else {
            // 当维修类型为外部维修时，填入客户自定义物料信息
            for (let a = 0; a < this.services.length; a++) {
              this.sendform.push({
                LotCode: this.services[a].LotCode,
                ConditionId: this.services[a].ConditionId,
                ProductName: this.services[a].ProductName,
                BrandName: this.services[a].BrandName,
                ModuleName: this.services[a].ModuleName,
                ModelName: this.services[a].ModelName,
                Description: this.services[a].Description,
                Quantity: this.services[a].Quantity,
              })
            }
          }
          const RepairOrder = o('RepairOrder')
          let updateRegion = []
          for (let i = 0; i < this.regions.length; i++) {
            if (this.ruleForm.region === this.regions[i].Id) {
              updateRegion = this.regions[i]
            }
          }
          const form = {
            RepairType: this.ruleForm.library,
            Region: updateRegion,
            RegionId: this.ruleForm.region,
            PartnerId: 1,
            Notes: '测试维修订单备注',
            Lines: this.sendform,
          }
          RepairOrder.post(form).save().then((data) => {
            // 提交成功
            loading.close()
            this.$alert('待后台确认后将完善您的维修订单详情信息', '提交成功', {
              confirmButtonText: '确定',
              type: 'success',
            }).then(() => {
              this.$router.push('/repair')
            })
          }).catch(() => {
            // 提交失败
            loading.close()
            if (form.RepairType === '' || form.PartnerId === '') {
              this.$message({
                message: '提交失败, 不能为空',
                type: 'info',
              })
            } else {
              this.$message({
                message: '提交失败,请填写完整信息',
                type: 'info',
              })
            }
          })
        } else {
          this.$message({
            message: '请填写必填内容',
            type: 'warning',
          })
        }
      })
    },
    pullLots: function(s) {
      const Lot = o('Lot').select('Id,Code').filter('ProductId eq ' + s.ProductId).top(20)
      Lot.get().then(({ data, inlinecount }) => {
        this.Lots = data
      }).catch((data) => {
      })
    },
    initRegion: function() {
      const Region = o('Region')
      Region.get().then(({ data, inlinecount }) => {
        this.regions = data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initservices: function() {
      this.services.push({
        ProductId: '',
        ConditionId: '',
        Module: '',
        LotId: '',
        Description: '',
        Quantity: 1,
      })
    },
    // 初始化模块下拉框
    initModules: function() {
      // 获取数据
      o('ProductModule').select('Id,Name').get()
        .then((data) => {
          // 绑定数据源
          this.modules = data.data
        })
    },
    // 初始化区域下拉框
    initRegions: function() {
      // 获取数据
      o('Region').select('Id,Code,Name').get()
        .then((data) => {
          // 绑定数据源
          this.regions = data.data
        })
    },
    initProductCondition: function() {
      const Condition = o('ProductCondition')
      Condition.get().then((data) => {
        this.ProductCondition = data.data
      }).catch((data) => { })
    },
    deleteItem: function(index) {
      this.$confirm('是否确认删除?', '删除批次', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.services.splice(index, 1)
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    NameCode: function(item) {
      return item.Name + '-' + item.Code
    },
    remoteMethod: function(value) {
      if (value) {
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.SearchProductIdLoading = true
          o('Product').select('Id,Code,Name').where(`contains(Name, '${value}')`).top(20).get()
            .then(({ data }) => {
              this.SearchProductIdLoading = false
              this.materiels = data
            })
        }, 500)
      } else {
        this.materiels = []
        this.SearchProductIdLoading = false
      }
    },
    // 远程搜索批次号
    remoteLot: function(value) {
      const Lot = o('Lot').select('Id,Code').filter('ProductId eq ' + this.changeProductId)
      if (value) {
        clearTimeout(timer)
        timer = setTimeout(() => {
          this.SearchProductIdLoading = true
          Lot.where(`contains(Code, '${value}')`).top(20).get()
          .then(({data}) => {
            this.Lots = data
          })
        }, 500)
      } else {
        this.Lots = []
      }
    },
    // 退出新增维修单页面
    cencelBtn: function() {
      this.$router.push('/repair')
    },
    addBatch: function() {
      this.services.push({
        ProductId: '',
        ConditionId: '',
        LotId: '',
        Module: '',
        Description: '',
        Quantity: 1,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.newrepair-page {
  .quantityLabel{
    margin: 0 auto;
    display: block;
    width: 10px;
    margin-top: 5px;
    height: 32px;
    line-height: 32px;
  }
  .el-form .el-form-item {
    display: inline-block;
  }
  .breadcrumb.el-breadcrumb {
    font-size: 26px;
    margin: 10px 0 30px;
  }
  .el-breadcrumb__item__inner,
  .el-breadcrumb__item__inner a {
    color: #20a0ff;
    font-size: 26px;
  }
  .el-breadcrumb__item:last-child .el-breadcrumb__item__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__item__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__item__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__item__inner:hover {
    color: #a6afb7;
    font-size: 18px;
    line-height: 26px;
  }
  .el-form-item{
    display: inline-block;
  }
  .card{
    background: #fff;
    border-radius: 4px 4px 6px 6px;
    border-top: 5px solid #808080;
    box-sizing: border-box;
    position: relative;
    padding: 20px 15px;
  }
  .item-box {
    position: relative;
    padding: 20px;
    background-color: #fff;
    margin-bottom: 25px;
    border: 1px solid #E1E8EE;
    width: 90%;
    .el-select,
    .el-input {
      width: 100%;
    }
    .delete-btn {
      position: absolute;
      right: -60px;
      top: 35%;
      background-color: #FF4949;
      color: #fff;
      padding: 10px 12px;
      border-radius: 50%;
      border: none;
    }
    table {
      display: inline-block;
      label {
        display: block;
        margin-bottom: 5px;
      }
      td {
        padding-right: 20px;
      }
      td:last-child {
        padding-right: 0;
      }
    }
  }
  .btn-box {
    margin-top: 20px;
  }
  
}

</style>
<style>
.newrepair-page .productName .el-form-item__content{
  margin-left: 0px !important;
}
</style>




// WEBPACK FOOTER //
// NewRepairPage.vue?67fc688d